import { useQuery } from '@tanstack/react-query';

import { AmendmentVersionGroup } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useGroupAmendments = (lrn: string) =>
  useQuery({
    queryKey: ['group-amendments', lrn],
    queryFn: async (): Promise<AmendmentVersionGroup[]> => {
      try {
        const { data } = await request({
          path: `declarations/${lrn}/amendments`,
          method: 'GET',
          authenticate: true,
        });

        return data;
      } catch (error) {
        showErrorToast(error, 'Failed to fetch amendments');
      }
    },
    enabled: !!lrn,
  });
